import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { DatePipe, formatDate } from '@angular/common'
import { LeadsService } from '../../_service/leads.service';
import { SharedService } from '../../_service/shared.service';
import { ActivatedRoute, Router  } from '@angular/router';
import {PageEvent, MatPaginator} from '@angular/material/paginator';
declare var $: any;

@Component({
  selector: 'app-booked-meeting-room-list',
  templateUrl: './booked-meeting-room-list.component.html',
  styleUrls: ['./booked-meeting-room-list.component.css'],
  host: {
    "(click)": "DeleteMeetingRoomRequest($event.target.id)"
 }
})

export class BookedMeetingRoomListComponent implements OnInit {
  perpage:number=25;booked_rooms:any=[];length:number=0;pageEvent: PageEvent;loading:boolean=true;myrole:string;treatment='';userId:string;
  pageSizeOptions = [10,25,50,100,200,500];pageIndex:number=0;bds=[];loaded:boolean=false;
  meetingRoomList:any=[];meeting_room='';start_date='';end_date='';booking_data=[];getDate="";getDateWhole="";displayDate="";meeting_room_access:string;

  @ViewChild('paginatorBottom', {static: false}) paginatorBottom: MatPaginator;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  /* @ViewChild('dateRangeStart', {static: false}) dateRangeStart: ElementRef;
  @ViewChild('dateRangeEnd', {static: false}) dateRangeEnd: ElementRef; */
  @ViewChild('dateRangeStart', {static: false}) dateRangeStart: ElementRef;

  constructor(private leadapi:LeadsService,private sharedapi:SharedService,private route:ActivatedRoute, private router: Router,private activatedRoute: ActivatedRoute, private elem: ElementRef, public datepipe: DatePipe) { 
    
  }

  ngOnInit(): void {
    this.sharedapi.getRole();
    this.sharedapi.getRole().subscribe((item:string) => {this.myrole=item;});
    this.myrole = localStorage.getItem('role');
    this.userId = localStorage.getItem('loginuserId');
    this.meeting_room_access = localStorage.getItem('meeting_room_access');
    /* if((this.myrole=='1' || this.myrole=='3' || this.myrole=='5' || this.myrole=='6' || this.myrole=='9' || this.userId == '19' || this.userId == '20' || this.userId == '177' || this.userId == '114') && this.userId != '205' && this.userId != '236') */
    if(this.meeting_room_access == '1') 
    {
      this.getMeetingRoomList();
    }
    else
    {
      this.router.navigateByUrl('/dashboard');
    }
    
    
  }

  ngAfterViewInit() {
    this.getbookingdata();
    /* this.loadBookedMeetingRooms(0,this.perpage); */
     
  }

  async loadBookedMeetingRooms(pageIndex,perpage)
  {
      this.booked_rooms = [];
      this.paginator.pageIndex = pageIndex;
      this.paginatorBottom.pageIndex = pageIndex;
      this.pageIndex = pageIndex;
      let qString = 'meeting_room='+this.meeting_room+'&date_range='+this.start_date+'-'+this.end_date;
      this.loading = true;
      this.loaded = false;
      this.leadapi.getBookedMeetingRooms(this.paginator.pageIndex,perpage,qString).subscribe((data:any) => {
          this.length = parseInt(data.totaldata);
          this.loading = false;
          this.loaded = true;
          if(data.status)
          {
            this.booked_rooms = data.data;
          }else{
            this.booked_rooms = [];
          }
      }, error => {
          this.loading = false;
          this.loaded = true;
          this.sharedapi.checkError(error);
      });
  }

  public getServerData(event:PageEvent):any
  {
      this.perpage = event.pageSize;
      this.pageIndex = event.pageIndex;
      this.loadBookedMeetingRooms(event.pageIndex,event.pageSize);
  }

  async getMeetingRoomList()
  {
      await this.leadapi.getMeetingRoomList().subscribe((data:any) => {
          if(data.status)
          {
            this.meetingRoomList = data.data;
          }else{
              this.meetingRoomList = [];
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

  dateRangeChange(date1,date2)
  {
      if(date2.value)
      {
          this.start_date = date1.value;
          this.end_date = date2.value;
          this.loadBookedMeetingRooms(0,this.perpage);
      }
  }

  /* clearDate()
  {
      this.dateRangeStart.nativeElement.value = "";
      this.dateRangeEnd.nativeElement.value = "";
      this.start_date = '';
      this.end_date = '';
      this.loadBookedMeetingRooms(0,this.perpage);
  } */

  getbookingdata()
  {
    this.loading = true;
    this.loaded = false;
    if(this.getDate)
    {
      this.getDate = this.getDate;
      this.displayDate = formatDate(this.getDate, 'dd, MMM yyyy', 'en');
    } else
    {
      this.getDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
      this.displayDate = formatDate(new Date(), 'dd, MMM yyyy', 'en');
    }
    this.leadapi.getMeetingsByTimeandDate(this.getDate).subscribe((data:any) => {
      this.loading = false;
      this.loaded = true;
      if(data.status)
      {
        this.booking_data = data.data;
      }else{
        this.booking_data = [];
      }
    }, error => {
      this.loading = true;
      this.loaded = false;
      this.sharedapi.checkError(error);
    });
    
    
  }

  getDatewiseData(event)
  {
    this.getDateWhole = event.target.value;
    this.getDate = this.datepipe.transform(this.getDateWhole, 'yyyy-MM-dd');
    this.getbookingdata();
  }

  clearDate()
  {
      this.dateRangeStart.nativeElement.value = "";
      this.getDate = '';
      this.getbookingdata();
  }

  DeleteMeetingRoomRequest(id){
    console.log($.isNumeric(id));
    if($.isNumeric(id)){
      if(confirm("Are you sure to delete this Records")) {
        
        this.leadapi.deleteMeetingRequest(id)
        .subscribe((data:any) => {
            this.loading = false;
            if(data.status)
            {
                this.sharedapi.presentToast('Record Deleted Successfully');
                this.getbookingdata();

            }
            else
            {
                this.sharedapi.presentToast(data.msg);
            }
        }, error =>
        {
            this.sharedapi.checkError(error);
        });
      }
    }
    
  }
  

}
